import { LoadDoctorDaysAvailable } from 'domain/usecases/doctor/load-doctor-days-available'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadDoctorDaysAvailable implements LoadDoctorDaysAvailable {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(
    params?: LoadDoctorDaysAvailable.Params
  ): Promise<LoadDoctorDaysAvailable.Model> {
    return this.doctorRepository.loadDoctorDaysAvailable(params)
  }
}
